import { lazy, Suspense, useEffect, useState } from "react";

const NotificationHosts = lazy(() => import("./NotificationHosts"));
const notificationIntentEvents = ["pointerdown", "keydown", "click"] as const;

export default function DeferredNotificationHosts() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const activate = () => {
      for (const eventName of notificationIntentEvents) {
        window.removeEventListener(eventName, activate, true);
      }
      window.clearTimeout(timeoutId);
      setReady(true);
    };
    const timeoutId = window.setTimeout(activate, 5_000);

    for (const eventName of notificationIntentEvents) {
      window.addEventListener(eventName, activate, { capture: true });
    }

    return () => {
      for (const eventName of notificationIntentEvents) {
        window.removeEventListener(eventName, activate, true);
      }
      window.clearTimeout(timeoutId);
    };
  }, []);

  if (!ready) return null;
  return (
    <Suspense fallback={null}>
      <NotificationHosts />
    </Suspense>
  );
}
